import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router-dom";

// redux
import { AppDispatch, RootState } from "redux/store";

// hoooks
import { common } from "includes";

// code splitting and lazy loading
// https://blog.logrocket.com/lazy-loading-components-in-react-16-6-6cea535c0b52
const TopbarMobile = React.lazy(() => import("./TopbarMobile"));

const MobileLayout = () => {
  const dispatch = useDispatch<AppDispatch>();

  const {
    // layoutType,
    layoutTheme,
    // sideBarType,
    // showSideBarUserInfo,
    // isOpenRightSideBar,
  } = useSelector((state: RootState) => ({
    layoutType: state.Layout.layoutType,
    layoutTheme: state.Layout.layoutTheme,
    layoutWidth: state.Layout.layoutWidth,
    topBarTheme: state.Layout.topBarTheme,
    sideBarTheme: state.Layout.sideBarTheme,
    sideBarType: state.Layout.sideBarType,
    layoutPosition: state.Layout.layoutPosition,
    showSideBarUserInfo: state.Layout.showSideBarUserInfo,
    isOpenRightSideBar: state.Layout.isOpenRightSideBar,
  }));

  /**
   * Layout defaults
   */

  useEffect(() => {
    common.changeHTMLAttribute("data-layout", "topnav");
  }, [dispatch]);

  useEffect(() => {
    common.changeHTMLAttribute("data-bs-theme", layoutTheme);
  }, [layoutTheme]);

  return (
    <Suspense fallback={<div />}>
      <div className="wrapper">
        <Suspense fallback={<div />}>
          <TopbarMobile />
        </Suspense>
        <div className="content">
          <Suspense fallback={<div />}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </Suspense>
  );
};

export default MobileLayout;
